import Swiper, { Thumbs, Navigation, Zoom, EffectFade, Scrollbar } from "swiper/core"

Swiper.use([Thumbs, Navigation, Zoom, EffectFade, Scrollbar])

const productGallery = {
  initThumbnails() {
    const thumbnails = document.querySelector('.product-gallery-thumbnails')
    if (!thumbnails) return false

    return new Swiper('.product-gallery-thumbnails', {
      slidesPerView: 3,
      spaceBetween: 16,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true
      },
      breakpoints: {
        // when window width is >= 768px
        768: {
          slidesPerView: 6,
        },
        // when window width is >= 1025px
        1025: {
          slidesPerView: 5,
        }
      }
    })
  },
  initGallery() {
    const gallery = document.querySelector('.product-gallery')
    if (!gallery) return

    return new Swiper('.product-gallery', {
      spaceBetween: 10,
      navigation: {
        nextEl: '.product-gallery-next',
        prevEl: '.product-gallery-prev'
      },
      thumbs: {
        swiper: this.initThumbnails()
      },
      zoom: {
        toggle: false
      },
      breakpoints: {
        1024: {
          simulateTouch: false,
          speed: 0
        }
      },
      on: {
        slideChange: () => {
          document.querySelectorAll('.product-gallery iframe, .product-gallery video').forEach(el => {
            if (el.tagName.toLowerCase() === 'video') {
              el.pause()
            } else {
              const src = el.src
              el.src = src
            }
          })
        }
      }
    })
  },
  filterMedia(id) {
    // Get Sliders
    const thumbnails = document.querySelector('.product-gallery-thumbnails').swiper
    const gallery = document.querySelector('.product-gallery').swiper

    // Destroy Sliders
    thumbnails.destroy()
    gallery.destroy()

    // Get All Slides
    const slides = document.querySelectorAll('.product-slide')
    const gallerySlides = document.querySelectorAll('.product-gallery .product-slide')
    const galleryThumbnailsSlides = document.querySelectorAll('.product-gallery-thumbnails .product-slide')
    let svgPositionArray = []

    if (gallerySlides.length > 0) {
      // Remove slide class from slides
      slides.forEach(slide => {
        slide.classList.remove('swiper-slide')
        slide.classList.add('hidden')

        const zoomIcon = slide.getElementsByClassName('product-gallery-zoom-icon')

        if (zoomIcon.length) {
          zoomIcon[0].removeAttribute('data-fslightbox')
        }
      })

      // Get Slides with Matching ID
      slides.forEach(slide => {
        if (slide.dataset.id.indexOf(id) !== -1) {
          // Add slide class to slides
          slide.classList.add('swiper-slide')
          slide.classList.remove('hidden')

          const zoomIcon = slide.getElementsByClassName('product-gallery-zoom-icon')

          if (zoomIcon.length) {
            zoomIcon[0].setAttribute('data-fslightbox', "gallery")
          }
        }
      })

      galleryThumbnailsSlides.forEach(thumbSlide => {
        if (thumbSlide.dataset.id.indexOf(id) !== -1) {
          const playIcon = thumbSlide.getElementsByClassName('product-gallery-play-icon')

          if (playIcon.length) {
            const playIconClone = playIcon[0].cloneNode(true)
            svgPositionArray.push(playIconClone)
          } else {
            svgPositionArray.push(undefined)
          }
        }
      })
    }

    // Reinit Sliders
    this.initGallery()
    document.querySelector('.product-gallery-container').classList.remove('invisible')

    const prevArrow = document.querySelector('.product-gallery-prev');
    const nextArrow = document.querySelector('.product-gallery-next');

    if (prevArrow.classList.contains('swiper-button-disabled') && nextArrow.classList.contains('swiper-button-disabled')) {
      prevArrow.classList.add('hidden');
      nextArrow.classList.add('hidden');
    } else {
      prevArrow.classList.remove('hidden');
      nextArrow.classList.remove('hidden');
    }

    // Refresh FsLightbox
    refreshFsLightbox()
    fsLightboxInstances['gallery'].props.thumbsIcons = svgPositionArray
    fsLightboxInstances['gallery'].props.showThumbsOnMount = true
  },

  init() {
    this.initGallery()
  }
}

export default productGallery